<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col sm="12" md="7">
                <media-index ref="media"></media-index>
            </v-col>
            <v-col sm="12" md="5">
                <tag-index @edited="loadTags"></tag-index>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import MediaIndex from './medias/Index'
import TagIndex from './tags/Index'

export default {
    components: {
        'media-index': MediaIndex,
        'tag-index': TagIndex,
    },

    methods: {
        loadTags() {
            this.$refs.media.getAllTags()
        },
    },
}
</script>
